import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import styled from 'styled-components';
import { GRADIENT, WHITE } from '../../styles/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentWrapper = styled.div.withConfig({
  displayName: "AIBadge__ContentWrapper",
  componentId: "p04e9z-0"
})(["height:20px;width:32px;padding:0;border-radius:4px;background:", ";color:", ";font-weight:300;user-select:none;.ai-icon{line-height:20px !important;margin-right:2px;vertical-align:top;span{text-transform:none !important;}}"], GRADIENT['DARK'], WHITE);
const StyledBadge = styled(UIBadge).withConfig({
  displayName: "AIBadge__StyledBadge",
  componentId: "p04e9z-1"
})(["padding:0;background:", ";height:20px;width:32px;"], GRADIENT['DARK']);
export const AIBadge = ({
  tooltip
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiComponentsUiLibrary.components.aiBadge.tooltip"
    }),
    children: /*#__PURE__*/_jsx(StyledBadge, {
      children: /*#__PURE__*/_jsxs(ContentWrapper, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "breezeSingleStar",
          size: 8,
          className: "ai-icon",
          color: WHITE
        }), /*#__PURE__*/_jsx("span", {
          children: "AI"
        })]
      })
    })
  });
};